<template>
  <div>
    <Toast></Toast>
    <ConfirmDialog></ConfirmDialog>
    <!-- card payment method -->
    <Dialog
      :focusTrap="false"
      v-model:visible="cardModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <hr />
      <h4 class="font-weight-bold h4-responsive">
        Payment Verfication will be Done
      </h4>
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.holderName != null ? 'focused' : '']"
        >
          <input
            type="text"
            class="form-control"
            id="chName"
            tabindex="1"
            aria-labelledby="cname"
            maxlength="100"
            v-model="aSinglePaymentReceived.holderName"
          /><span class="bar"></span>
          <label for="chName" id="cname"
            >Card Holder Name<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.tdNumber != null ? 'focused' : '']"
        >
          <input
            v-mask="'####-####-####-####'"
            type="tel"
            class="form-control"
            id="cNumber"
            tabindex="2"
            aria-labelledby="cardNum"
            v-model="aSinglePaymentReceived.tdNumber"
          /><span class="bar"></span>
          <label for="cNumber" id="cardNum"
            >Card Number<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[
            aSinglePaymentReceived.ExpirationDate != null ? 'focused' : '',
          ]"
        >
          <input
            v-model="aSinglePaymentReceived.ExpirationDate"
            type="month"
            class="form-control required"
            id="filler_name"
            name="filler_name"
            tabindex="3"
          /><span class="bar"></span>
          <label for="exdate" id="exdate"
            >Expiration Date<span style="color: red"> *</span></label
          >
        </div>

        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.cardCVC != null ? 'focused' : '']"
        >
          <input
            v-mask="'######'"
            type="tel"
            class="form-control"
            id="cvc"
            aria-labelledby="cardCVC"
            v-model="aSinglePaymentReceived.cardCVC"
            tabindex="4"
          /><span class="bar"></span>
          <label for="cvc" id="cardCVC"
            >Card CVC<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.zip != null ? 'focused' : '']"
        >
          <input
            type="text"
            class="form-control"
            id="cardzip"
            aria-labelledby="czip"
            maxlength="8"
            tabindex="5"
            v-model="aSinglePaymentReceived.zip"
          /><span class="bar"></span>
          <label for="cardzip" id="czip"
            >Zip<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          :class="[aSinglePaymentReceived.amount != null ? 'focused' : '']"
        >
          <input
            type="number"
            class="form-control"
            id="cAmount"
            aria-labelledby="amnt"
            @keypress="isNumber($event)"
            :max="limitAmount"
            disabled
            tabindex="6"
            v-model="aSinglePaymentReceived.amount"
          /><span class="bar"></span>
          <label for="cAmount" id="amnt"
            >Amount<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment != null ? 'focused' : '',
          ]"
        >
          <textarea
            class="form-control"
            id="cardCmnt"
            aria-labelledby="commnt"
            maxlength="255"
            tabindex="7"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
          <label for="cardCmnt" id="commnt" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('credit-card')"
        >
          Process
        </button>
      </template>
    </Dialog>
    <!-- cash payment method -->
    <Dialog
      v-model:visible="cashModal"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <hr />
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.amount != null ? 'focused' : '',
          ]"
        >
          <input
            type="number"
            class="form-control"
            id="cashAmount"
            aria-labelledby="camount"
            @keypress="isNumber($event)"
            disabled
            v-model="aSinglePaymentReceived.amount"
            :max="limitAmount"
          /><span class="bar"></span>
          <label for="cashAmount" id="camount"
            >Amount(In $)<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
          ]"
        >
          <label for="cashCmnt" id="cComment" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
          <textarea
            maxlength="255"
            class="form-control"
            id="cashCmnt"
            aria-labelledby="cComment"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('cash')"
        >
          Collect
        </button>
      </template>
    </Dialog>
    <!-- cheque payment method -->
    <Dialog
      :focusTrap="true"
      v-model:visible="chequeModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <hr />
      <form class="floating-labels m-t-40">
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.tdNumber.length > 0 ? 'focused' : '',
          ]"
        >
          <input
            class="form-control"
            id="chkNumber"
            @keyup.tab="gotoCheckHolderName()"
            aria-labelledby="chk"
            v-model="aSinglePaymentReceived.tdNumber"
          /><span class="bar"></span>
          <label for="chkNumber" id="chk"
            >Cheque Number<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.amount != null ? 'focused' : '',
          ]"
        >
          <input
            type="number"
            class="form-control"
            id="chkAmount"
            aria-labelledby="chkamnt"
            @keypress="isNumber($event)"
            v-model="aSinglePaymentReceived.amount"
            disabled
            :max="limitAmount"
          /><span class="bar"></span>
          <label for="chkAmount" id="chkamnt"
            >Amount(In $)<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group m-b-40"
          v-bind:class="[
            aSinglePaymentReceived.holderName.length > 0 ? 'focused' : '',
          ]"
        >
          <input
            type="text"
            class="form-control"
            id="cholderNAme"
            aria-labelledby="cnam"
            @keypress.tab="gotoComment()"
            ref="checkHolderNameRef"
            maxlength="100"
            v-model="aSinglePaymentReceived.holderName"
          /><span class="bar"></span>
          <label for="cholderName" id="cnam"
            >Cheque Holder Name<span style="color: red"> *</span></label
          >
        </div>
        <div
          class="form-group"
          v-bind:class="[
            aSinglePaymentReceived.comment.length > 0 ? 'focused' : '',
          ]"
        >
          <label for="chComment" id="chdnam" class="control-label"
            >Comment<span style="color: red"> *</span>:</label
          >
          <textarea
            class="form-control"
            id="chComment"
            aria-labelledby="chdnam"
            maxlength="255"
            ref="commentRef"
            v-model="aSinglePaymentReceived.comment"
          ></textarea
          ><span class="bar"></span>
        </div>
      </form>
      <template #footer>
        <button
          :disabled="btnProColl == true"
          type="button"
          class="btn btn-outline-success waves-effect waves-light col-12"
          id="chequePayment"
          style="width: 100%"
          @click="paymentReceivedClick('cheque')"
        >
          Collect
        </button>
      </template>
    </Dialog>
    <!-- payment method modal -->
    <Dialog
      :focusTrap="false"
      v-model:visible="displayPayMethod"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="top"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Payment Method</h4>
      </template>
      <form>
        <div class="row text-center">
          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(1)">
              <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Credit Or Debit Card</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(2)">
              <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cash</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitPaymentModal(3)">
              <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cheque</h4>
            </a>
          </div>
        </div>
      </form>
    </Dialog>
    <Dialog
      :focusTrap="false"
      v-model:visible="refundAmountModal"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="center"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">
          <strong> Enter Refund Amount</strong>
        </h4>
      </template>
      <div>
        <div class="form-group focused" style="">
          <input
            type="text"
            class="form-control"
            id="refund"
            tabindex="1"
            v-model="refundAmount"
            :placeholder="
              'Amount Refunded (In $$), can not be greater then $' +
              (ActivePaymentRequest.amount - ActivePaymentRequest.refundAmount)
            "
            aria-labelledby="cname"
            :max="ActivePaymentRequest.amount"
            @keypress="amountRefundCheck($event, refundAmount)"
          />
        </div>
      </div>
      <template #footer>
        <div class="swal2-actions" style="display: flex; margin-top: -10px">
          <button
            type="button"
            class="swal2-confirm swal2-styled"
            aria-label=""
            style="
              display: inline-block;
              background-color: rgb(0, 194, 146);
              border-left-color: rgb(0, 194, 146);
              border-right-color: rgb(0, 194, 146);
              margin: 15px;
            "
            @click="refundPayment()"
          >
            Refund
          </button>
          <button
            type="button"
            class="swal2-cancel swal2-styled"
            aria-label=""
            @click="closeRefundAmountModal()"
            style="display: inline-block; margin: 15px"
          >
            Cancel
          </button>
        </div>
      </template>
    </Dialog>
    <!-- Choose refund Method modal -->
    <Dialog
      :focusTrap="false"
      v-model:visible="displayRefundMethod"
      style="width: 30%; max-height: 100%"
      @hide="closeModalRem()"
      position="top"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Select A Refund Method</h4>
      </template>
      <form>
        <div class="row text-center">
          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitRefundModal(1)">
              <i class="far fa-credit-card fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Credit Or Debit Card</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitRefundModal(2)">
              <i class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cash</h4>
            </a>
          </div>

          <div class="col m-2 p-2">
            <a href="javascript:void(0)" @click="showSubmitRefundModal(3)">
              <i class="fas fa-money-check-alt fa-5x mb-3 blue-text"></i>
              <h4 class="font-weight-bold">Cheque</h4>
            </a>
          </div>
        </div>
      </form>
    </Dialog>

    <Dialog
      :focusTrap="false"
      v-model:visible="displayRem"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">Reminder</h4>
      </template>

      <div class="row">
        <div class="col-12" style="margin-top: 22px">
          <div class="form-group">
            <span class="p-float-label">
              <InputText
                v-model="Reminder.email"
                style="width: 400px"
                type="text"
                id=""
                placeholder=""
              />
              <label id="font1">Email</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <span class="p-float-label">
              <InputMask
                v-model="Reminder.phone"
                mask="***-***-****"
                style="width: 400px"
              />
              <label id="font1">Phone Number</label>
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          @click="sendReminderClick()"
          class="btn btn-success waves-effect waves-light"
        >
          Send
        </button>
        <button
          type="button"
          @click="closeModalRem()"
          class="btn btn-danger waves-effect waves-light"
        >
          Close
        </button>
      </div>
    </Dialog>
    <Dialog
      v-model:focusTrap="displayReceipt"
      v-model:visible="displayReceipt"
      style="width: 30%; max-height: 40%"
      @hide="closeModalRem()"
      :modal="true"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">
          Send Receipt to following details
        </h4>
      </template>

      <div class="row">
        <div class="col-12" style="margin-top: 22px">
          <div class="form-group">
            <span class="p-float-label">
              <InputText
                v-model="SendReceiptRequest.Email"
                style="width: 400px"
                type="text"
                id=""
                placeholder=""
              />
              <label id="font1">Email</label>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <span class="p-float-label">
              <InputMask
                v-model="SendReceiptRequest.Phone"
                mask="***-***-****"
                style="width: 400px"
              />
              <label id="font1">Phone Number</label>
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          @click="sendReceiptClick()"
          class="btn btn-success waves-effect waves-light"
        >
          Send
        </button>
        <button
          type="button"
          @click="closeRecepit()"
          class="btn btn-danger waves-effect waves-light"
        >
          Close
        </button>
      </div>
    </Dialog>
    <Dialog
      :focusTrap="false"
      v-model:visible="showThisModel"
      style="width: 70%; max-height: 90%"
      @hide="closeModal()"
      :maximizable="true"
      :modal="modelBackDrop"
    >
      <template #header>
        <h4 class="modal-title" id="myModalLabel">{{ heading }}</h4>
      </template>

      <!-- <Menu :model="menuitems" style="width:150px;"/> -->

      <div class="vtabs customvtab">
        <ul class="nav nav-tabs tabs-vertical" role="tablist">
          <!-- <li class="nav-item">
            <a
              :class="classActiveOption('merge')"
              data-toggle="tab"
              role="tab"
              href="#customDemo3"
              @click="mergeClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Merge patients</span>
            </a>
          </li> -->
          <li class="nav-item">
            <a
              :class="classActiveOption('visittype')"
              data-toggle="tab"
              href="#insuranceList3"
              role="tab"
              @click="visitTypeClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Edit Visit Type</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="classActiveOption('questionn')"
              data-toggle="tab"
              role="tab"
              href="#customDemo3"
              @click="questionnClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Questionnaire</span>
            </a>
          </li>

          <li class="nav-item">
            <a
              :class="classActiveOption('comment')"
              data-toggle="tab"
              href="#customDemo3"
              role="tab"
              @click="commentClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Comment Left</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="classActiveOption('sms')"
              data-toggle="tab"
              href="#paymentRequestList3"
              role="tab"
              @click="sendTextClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Send Text</span>
            </a>
          </li>
          <li class="nav-item">
            <a
              :class="classActiveOption('email')"
              data-toggle="tab"
              href="#visitHistory3"
              role="tab"
              @click="sendEmailClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Send Email</span></a
            >
          </li>
          <li class="nav-item">
            <a
              :class="classActiveOption('collectpayment')"
              data-toggle="tab"
              href="#paymentHistory3"
              role="tab"
              @click="collectPaymentClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down">Collect Payment</span></a
            >
          </li>
          <li class="nav-item">
            <a
              id="emailHistory1221"
              :class="classActiveOption('request-payment')"
              data-toggle="tab"
              href="#emailHistory"
              role="tab"
              @click="requestPaymentClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down"
                >Request payment<span
                  class="badge badge-danger mr-1"
                ></span></span
            ></a>
          </li>
          <li class="nav-item">
            <a
              id="textHistory1221"
              :class="classActiveOption('physician')"
              data-toggle="tab"
              href="#textHistory3"
              role="tab"
              @click="assignPhysicianClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down"
                >Assign Physician<span
                  class="badge badge-danger mr-1"
                ></span></span
            ></a>
          </li>

          <li class="nav-item">
            <a
              id="textHistory1221"
              :class="classActiveOption('Resource')"
              href="#textHistory3"
              data-toggle="tab"
              role="tab"
              @click="assignResourceClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down"
                >Assign Resource<span
                  class="badge badge-danger mr-1"
                ></span></span
            ></a>
          </li>
          <li class="nav-item">
            <a
              id="textHistory1221"
              :class="classActiveOption('Tasks')"
              href="#textHistory3"
              data-toggle="tab"
              role="tab"
              @click="assignTaskClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down"
                >Assign Tasks to-do<span
                  class="badge badge-danger mr-1"
                ></span></span
            ></a>
          </li>
          <li class="nav-item">
            <a
              id="auditLogVisit"
              :class="classActiveOption('auditLog')"
              href="#textHistory3"
              data-toggle="tab"
              role="tab"
              @click="auditLogClick()"
              ><span class="hidden-sm-up"></span>
              <span class="hidden-xs-down"
                >Audit Log<span class="badge badge-danger mr-1"></span></span
            ></a>
          </li>
        </ul>

        <!-- Tab panes Questionnaire -->
        <!-- <div class="row col-12" v-if="showMerge">
          <MergePatients :p_visitId="p_visitId"/>
        </div> -->

        <div class="tab-content" style="width: 100%" v-if="showQuestionn">
          <div class="row col-12" v-if="visitQuests.length == 0">
            <h4>No Attached Questions to Visit Type and Reason</h4>
          </div>
          <div v-else>
            <button
              class="btn btn-outline-success waves-effect col-12"
              id="a1"
              @click="questSaveClick()"
            >
              Save
            </button>
          </div>
          <br />

          <div class="row col-12">
            <div
              class="col-6 fluid"
              v-for="(quest, ndxquest) in visitQuests"
              :key="ndxquest"
            >
              <!-- Question Number and Question Text -->
              <h4 style="margin-top: 10px">
                <b style="font-weight: bold">QID-{{ quest.questIdSerial }}: </b>
                <b>{{ quest.question }}</b>
              </h4>
              <!-- END Question Number and Question Text -->

              <!-- TextBox or Email question type -->
              <dir
                v-if="
                  quest.questionInputTypeId == 1 ||
                  quest.questionInputTypeId == 5
                "
                class="col-md-12 align-self-left text-left"
              >
                <InputText
                  type="text"
                  v-model="quest.answer"
                  style="width: 100%"
                  class="float-class"
                />
              </dir>
              <!-- End TextBox or Email question type -->
              <!-- Checkbox -->
              <dir
                v-if="quest.questionInputTypeId == 2"
                class="col-md-12 align-self-left text-left"
              >
                <div class="input-group">
                  <div
                    class="row"
                    v-for="(opt, ndxA1) in quest.options"
                    :key="ndxA1"
                  >
                    <div style="margin-right: 10px">
                      <input
                        class="input1"
                        type="checkbox"
                        value="3"
                        name="checkbox"
                        id=""
                      />
                      <label
                        for="checkbox1"
                        @click="
                          questMultipleOptionSelected(quest, opt.questOptionId)
                        "
                        :class="classQuestMultiple(quest, opt.questOptionId)"
                        >{{ opt.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </dir>
              <!-- End CheckBox -->
              <!-- Rating and Radio button -->
              <dir
                v-if="
                  quest.questionInputTypeId == 3 ||
                  quest.questionInputTypeId == 4
                "
                class="col-md-12 align-self-left text-left"
              >
                <div class="input-group">
                  <div
                    class="row"
                    v-for="(opt, ndxA1) in quest.options"
                    :key="ndxA1"
                  >
                    <div style="margin-right: 10px">
                      <input
                        class="input1"
                        type="checkbox"
                        value="3"
                        name="checkbox"
                        id=""
                      />
                      <label
                        for="checkbox1"
                        @click="
                          questSingleOptionSelected(quest, opt.questOptionId)
                        "
                        :class="
                          quest.answer == opt.questOptionId + ''
                            ? 'btn btn-info label1'
                            : 'btn btn-outline-info label1'
                        "
                        >{{ opt.questOption }}</label
                      >
                    </div>
                  </div>
                </div>
              </dir>
              <!-- End Rating and Radio button -->
              <!-- Phone -->
              <dir
                v-if="quest.questionInputTypeId == 6"
                class="col-md-12 align-self-left text-left"
              >
                <InputMask
                  v-model="quest.answer"
                  mask="999-999-9999"
                  style="width: 100%"
                  class="float-class"
                />
              </dir>
              <!-- End Phone -->
              <!-- Date -->
              <dir
                v-if="quest.questionInputTypeId == 7"
                class="col-md-12 align-self-left text-left"
              >
                <div class="floating-labels">
                  <div class="form-group">
                    <input
                      type="date"
                      class="form-control"
                      id=""
                      v-model="quest.answer"
                    /><span class="bar"></span>
                  </div>
                </div>
                <!-- <Calendar
                  :showIcon="true"
                  :showButtonBar="true"
                  v-model="quest.answer"
                  class="float-calendar"
                  style="width: 100%"
                ></Calendar> -->
              </dir>
              <!--End Date -->
            </div>
          </div>
        </div>

        <!-- Tab panes Comment -->
        <div class="tab-content" style="width: 100%" v-if="showCommentLeft">
          <div>
            <h3>Leave a Comment</h3>
            <br />
            <form>
              <div class="form-group">
                <label for="comment-text" class="control-label">Comment:</label>
                <textarea
                  v-model="commentText"
                  class="form-control"
                  id="comment-text"
                  rows="5"
                  autofocus
                ></textarea>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-outline-success waves-effect waves-light col-12"
                  @click="leaveCommentSaveClick()"
                >
                  Leave Comment
                </button>
              </div>

              <div class="form-group">
                <div
                  class="card"
                  v-for="(tc, ndx01) in commentsList"
                  :key="ndx01"
                >
                  <div class="timeline-heading">
                    <h4 class="" style="font-size: 20px; font-weight: 800">
                      {{ tc.commentFromName }}
                    </h4>
                    <p style="margin-top: -10px">
                      <small class="text-muted">
                        <i class="fa fa-clock-o"></i>{{ tc.commentLocalDate }}
                      </small>
                    </p>
                  </div>
                  <div class="timeline-body">
                    <p>{{ tc.commentText }}</p>
                  </div>

                  <hr v-if="showCommentLine(ndx01)" class="solid bg-white" />
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Tab panes Request assign resource -->
        <div class="tab-content" style="width: 100%" v-if="showResource">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">
                  Assign Resource
                </h4>
              </div>

              <div class="modal-body mb-1 pt-2">
                <ResourceComponent
                  ref="resourceComponent"
                  :p_visitId="p_visitId"
                  :FetchTableData="FetchTableData"
                ></ResourceComponent>
              </div>
            </div>
          </div>
        </div>
        <!-- Resource ID Modal -->
        <div class="tab-content" style="width: 100%" v-if="showTasks == true">
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Tasks to-do</h4>
          </div>

          <div class="modal-body mb-1 pt-2">
            <PatientTasksTable
              ref="patientTasksTableRef2"
              :patientId="patientId"
              :visitId="p_visitId"
              :FetchTableData="FetchTableData"
            >
            </PatientTasksTable>
          </div>
        </div>
        <div
          class="tab-content"
          style="width: 100%"
          v-if="showAuditLog == true"
        >
          <div class="modal-header">
            <h4 class="modal-title" id="myLargeModalLabel">Audit Log</h4>
          </div>

          <div class="modal-body mb-1 pt-2">
            <AuditLogComponent ref="auditLogComponent" :isModel="true">
            </AuditLogComponent>
          </div>
        </div>

        <!-- Tab panes showVisitType -->
        <div class="tab-content" style="width: 100%" v-if="showVisitType">
          <h3>Edit Visit Type</h3>
          <div class="modal-body">
            <form class="floating-labels m-t-40">
              <div
                class="form-group"
                :class="[pat.visitTypeId != null ? 'focused' : '']"
              >
                <label class="control-label">Visit Type</label>
                <select
                  class="form-control custom-select"
                  data-placeholder="Choose a Visit Type"
                  @change="resetVisitDetail()"
                  v-model="pat.visitTypeId"
                >
                  <!-- ***555*** -->
                  <option
                    v-for="(type, ndx05) in visitTypes"
                    :key="ndx05"
                    :value="type.visitTypeId"
                  >
                    {{ type.visitTypeName }}
                  </option>
                </select>
              </div>
              <br />
              <div
                class="form-group"
                :class="[pat.visitDetailId != null ? 'focused' : '']"
              >
                <label class="control-label">Visit Reason</label>
                <select
                  class="form-control custom-select"
                  data-placeholder="Choose a Visit Reason"
                  tabindex="1"
                  v-model="pat.visitDetailId"
                >
                  <option
                    v-for="(rea, ndx06) in activeVisitReasons"
                    :key="ndx06"
                    :value="rea.visitDetailId"
                  >
                    {{ rea.reasonName }}
                  </option>
                </select>
              </div>
            </form>
            <form>
              <div class="form-group m-b-40">
                <label class="control-label">Date of Service</label>
                <input
                  type="date"
                  class="form-control"
                  id="dos"
                  v-model="pat.dosStr"
                /><span class="bar"></span>
              </div>
            </form>
            <form>
              <div class="form-group m-b-40">
                <label class="control-label">Appointment Time</label>
                <input
                  type="time"
                  class="form-control"
                  id="appointmentTime"
                  v-model="pat.appointmentTime"
                /><span class="bar"></span>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-success waves-effect waves-light col-12"
              @click="updateTypeReasonClick()"
            >
              Update Visit Type
            </button>
          </div>
        </div>

        <!-- Tab panes CollectPayment -->
        <div class="tab-content" style="width: 100%" v-if="showCollectPayment">
          <!-- <h3>Select A Payment Method</h3> -->
          <!-- <div class="row col-12">
            <form>
              <div class="row text-center">
                <div
                  class="col m-2 p-2"
                  @click="paymentModeClicked('credit-card')"
                >
                  <a href="" data-target="#debit" data-toggle="modal">
                    <i
                      class="far fa-credit-card fa-5x mb-3 blue-text"
                      :style="paymentModeStyle('credit-card')"
                    ></i>
                    <h4
                      class="font-weight-bold"
                      :style="paymentModeStyle('credit-card')"
                    >
                      Credit Or Debit Card
                    </h4>
                  </a>
                </div>

                <div class="col m-2 p-2" @click="paymentModeClicked('cash')">
                  <a href="" data-target="#cash" data-toggle="modal">
                    <i
                      class="fas fa-hand-holding-usd fa-5x mb-3 blue-text"
                      :style="paymentModeStyle('cash')"
                    ></i>
                    <h4
                      class="font-weight-bold"
                      :style="paymentModeStyle('cash')"
                    >
                      Cash
                    </h4>
                  </a>
                </div>

                <div class="col m-2 p-2" @click="paymentModeClicked('cheque')">
                  <a href="" data-target="#cheque" data-toggle="modal">
                    <i
                      class="fas fa-money-check-alt fa-5x mb-3 blue-text"
                      :style="paymentModeStyle('cheque')"
                    ></i>
                    <h4
                      class="font-weight-bold"
                      :style="paymentModeStyle('cheque')"
                    >
                      Cheque
                    </h4>
                  </a>
                </div>

                <div
                  class="col m-2 p-2"
                  @click="paymentModeClicked('payment-requested')"
                >
                  <a href="" data-target="#paymentRequest" data-toggle="modal">
                    <i
                      class="fas fa-cash-register fa-5x mb-3 blue-text"
                      :style="paymentModeStyle('payment-requested')"
                    ></i>
                    <h4
                      class="font-weight-bold"
                      :style="paymentModeStyle('payment-requested')"
                    >
                      Payment Requested
                    </h4>
                  </a>
                </div>
              </div>
            </form>
          </div> -->

          <div class="row col-12" v-if="paymentMode === 'credit-card'">
            <h4 class="font-weight-bold h4-responsive">
              Payment Verfication will be Done
            </h4>
            <br /><br />
            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputText
                  id="inputtext"
                  type="text"
                  v-model="aSinglePaymentReceived.holderName"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Card Holder Name</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputMask
                  v-model="aSinglePaymentReceived.tdNumber"
                  mask="9999-9999-9999-9999"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Card Number</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputText
                  id="inputtext"
                  type="text"
                  v-model="aSinglePaymentReceived.cardCVC"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Card CVC</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputText
                  id="inputtext"
                  type="text"
                  v-model="aSinglePaymentReceived.zip"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Zip</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputNumber
                  showButtons
                  v-model="aSinglePaymentReceived.amount"
                  mode="decimal"
                  :maxFractionDigits="2"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Amount</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <label for="" class="control-label">Comment:</label>
              <textarea
                v-model="aSinglePaymentReceived.comment"
                maxlength="255"
                class="form-control"
                id="comment-text"
                rows="2"
                style="width: 100%"
              ></textarea>
            </div>
            <div class="modal-footer p-col-12">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                id="creditCardPayment"
                @click="paymentReceivedClick('credit-card')"
              >
                Process
              </button>
            </div>
          </div>

          <div class="row col-12" v-if="paymentMode === 'cash'">
            <h4 class="font-weight-bold h4-responsive">Cash On The Spot</h4>
            <br /><br />

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputNumber
                  showButtons
                  v-model="aSinglePaymentReceived.amount"
                  mode="decimal"
                  :maxFractionDigits="2"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Amount</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <label for="" class="control-label">Comment:</label>
              <textarea
                v-model="aSinglePaymentReceived.comment"
                maxlength="255"
                class="form-control"
                id="comment-text"
                rows="2"
                style="width: 100%"
              ></textarea>
            </div>
            <div class="modal-footer p-col-12">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                id="creditCardPayment"
                @click="paymentReceivedClick('cash')"
              >
                Process
              </button>
            </div>
          </div>

          <div class="row col-12" v-if="paymentMode === 'cheque'">
            <h4 class="font-weight-bold h4-responsive">Payment Via Cheque</h4>
            <br /><br />

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputMask
                  v-model="aSinglePaymentReceived.tdNumber"
                  mask="****-****-****-****"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Cheque Number</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputNumber
                  showButtons
                  v-model="aSinglePaymentReceived.amount"
                  mode="decimal"
                  :maxFractionDigits="2"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Amount(In $)</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputText
                  id="inputtext"
                  type="text"
                  v-model="aSinglePaymentReceived.holderName"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Cheque Holder Name</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <label for="" class="control-label">Comment:</label>
              <textarea
                v-model="aSinglePaymentReceived.comment"
                maxlength="255"
                class="form-control"
                id="comment-text"
                rows="2"
                style="width: 100%"
              ></textarea>
            </div>
            <div class="modal-footer p-col-12">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                id="creditCardPayment"
                @click="paymentReceivedClick('cheque')"
              >
                Process
              </button>
            </div>
          </div>

          <div class="card p-3" v-if="paymentMode === 'payment-requested'">
            <div v-show="false" class="table-responsive">
              <div class="dataTables_wrapper no-footer">
                <div class="dataTables_length">
                  <span style="margin-right: 10px"
                    ><label for="">Show </label>
                  </span>
                  <select
                    v-model="pageSize"
                    class="form-control form-control-sm"
                    aria-label="Default select example"
                    @change="pageChange(1)"
                  >
                    <option selected>50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                  </select>

                  <span style="margin-left: 10px">
                    <label for=""> Entries </label></span
                  >
                </div>
              </div>
              <table
                data-height="300"
                id="table001"
                class="table display dataTable table-bordered text-center table-striped no-wrap"
              >
                <thead class="thead-dark">
                  <tr>
                    <th style="text-align: start">
                      Action
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(0)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Status
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(1)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Patient Name
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(2)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Confirmation Number
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(3)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      PaymentID
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(4)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date of Service
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(5)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Date Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(6)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Sent to
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(7)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Amount Requested
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(8)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Refund Amount
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(9)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                    <th style="text-align: start">
                      Note
                      <span>
                        <button class="asc-desc-btn" @click="orderBy(10)">
                          &uarr; &darr;
                        </button>
                      </span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="(pay, ndx01) in filteredPaymentRequests"
                    :key="ndx01"
                  >
                    <td>
                      <div class="btn-group">
                        <!-- First Button -->
                        <button
                          v-if="pay.status == 1"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 2"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 5"
                          type="button"
                          style="
                            border-top-right-radius: 4px;
                            border-bottom-right-radius: 4px;
                          "
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="sendReceipt(pat, pay)"
                        >
                          <strong>Receipt </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 3"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Reminder</strong>
                        </button>
                        <button
                          v-else-if="pay.status == 4"
                          type="button"
                          class="btn btn-success"
                          style="
                            border-top-right-radius: 3px;
                            border-bottom-right-radius: 3px;
                          "
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 6"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 7"
                          type="button"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                          @click="paymentCollectMethodModal(pay)"
                        >
                          <strong>Collect Payment </strong>
                        </button>
                        <button
                          v-else-if="pay.status == 9"
                          type="button"
                          class="btn btn-danger"
                          :style="colorStyle(pay.status)"
                          @click="showSubmitRefundModal(pay)"
                        >
                          <strong>Refund</strong>
                        </button>
                        <span v-if="pay.status == 5"> </span>
                        <button
                          v-else-if="updButton == 1"
                          type="button"
                          class="btn btn-success dropdown-toggle dropdown-toggle-split"
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>

                        <button
                          v-else
                          type="button"
                          class="btn btn-success dropdown-toggle dropdown-toggle-split"
                          :style="colorStyle(pay.status)"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          :disabled="updButton == 0"
                        >
                          <span class="sr-only">Toggle Dropdown</span>
                        </button>
                        <div
                          v-if="pay.status == 4"
                          class="dropdown-menu animated flipInY"
                        >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pat, pay)"
                            >Receipt</a
                          >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReconcileModel(pay)"
                            >Reconciled</a
                          >
                        </div>
                        <div
                          v-if="pay.status == 6"
                          class="dropdown-menu animated flipInY"
                        >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pat, pay)"
                            >Receipt</a
                          >
                          <!-- <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReconcileModel(pay)"
                            >Reconciled</a
                          > -->
                        </div>
                        <div
                          v-if="pay.status == 9"
                          class="dropdown-menu animated flipInY"
                        >
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="sendReceipt(pat, pay)"
                            >Receipt</a
                          >
                          <a
                            v-if="pay.status == 1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>

                        <div v-else class="dropdown-menu animated flipInY">
                          <a
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="showReminderModel(pay)"
                            >Reminder</a
                          >
                          <a
                            v-if="pay.status == 1"
                            class="dropdown-item"
                            href="javascript:void(0)"
                            @click="deletePayment(pay)"
                            >Delete</a
                          >
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <span
                          v-if="pay.status == 1"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Requested
                        </span>
                        <span
                          v-else-if="pay.status == 2"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Pending
                        </span>
                        <span
                          v-else-if="pay.status == 3"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Disputed
                        </span>
                        <span
                          v-else-if="pay.status == 4"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Paid
                        </span>
                        <span
                          v-else-if="pay.status == 5"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Refunded
                        </span>
                        <span
                          v-else-if="pay.status == 6"
                          class="btn btn-success"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Refunded
                        </span>

                        <p
                          v-else-if="pay.status == 7"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Partially Paid
                        </p>
                        <p
                          v-else-if="pay.status == 9"
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          Reconciled
                        </p>
                      </div>
                    </td>
                    <td>{{ pay.firstName + " " + pay.lastName }}</td>
                    <td>
                      <div>
                        <span
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          BID{{ pay.billNo }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          PYI{{ pay.pndx }}
                        </span>
                      </div>
                    </td>
                    <td>{{ pay.dosStr }}</td>
                    <td>{{ pay.billDateStr }}</td>
                    <td>
                      <div>
                        <span
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          {{ pay.email }}
                        </span>
                      </div>
                      <br />
                      <div>
                        <span
                          class="bs-label label-danger badgeBorder"
                          :style="colorStyle(pay.status)"
                        >
                          {{ pay.phone }}
                        </span>
                      </div>
                    </td>
                    <td>
                      ${{ pay.amount }} <br />
                      {{ pay.paymentmethodStr }}
                      <span v-if="pay.paymentMethod == 1"> Processed </span>
                      <span v-else-if="pay.paymentMethod == 0"> </span>
                      <span v-else> Collected </span>
                      {{ pay.paymentDateStr }}
                    </td>
                    <td>
                      ${{ pay.refundAmount }} <br />
                      <span> {{ pay.refundDateStr }} </span>
                    </td>
                    <td>
                      {{ pay.comment }}<br />
                      <a
                        v-if="pay.uploadedFileUrl !== ''"
                        :href="pay.uploadedFileUrl"
                      >
                        View Attachment
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <nav
              v-show="false"
              aria-label="Page navigation "
              style="float: right"
            >
              <span
                style="padding-left: 40px"
                v-if="totalRows < pageSize * pageNumber"
                >showing {{ totalRows }} of {{ totalRows }} records</span
              >
              <span style="padding-left: 40px" v-else
                >showing {{ pageSize * pageNumber }} of
                {{ totalRows }} records</span
              >
              <ul class="pagination" style="float: right">
                <li class="page-item colorActive">
                  <span v-if="pageNumber == 1">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChange('Previous')"
                    >
                      Previous
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange('Previous')">
                      Previous
                    </button>
                  </span>
                </li>

                <li
                  v-for="pageNum in totalPages"
                  :key="pageNum"
                  class="page-item colorActive"
                >
                  <span v-if="pageNumber == pageNum"
                    ><button
                      class="page-link activeColor"
                      disabled
                      @click="pageChange(pageNum)"
                    >
                      {{ pageNum }}
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange(pageNum)">
                      {{ pageNum }}
                    </button></span
                  >
                </li>

                <li class="page-item colorActive">
                  <span v-if="pageNumber == totalPages">
                    <button
                      disabled
                      class="page-link disabledColor"
                      @click="pageChange('Next')"
                    >
                      Next
                    </button>
                  </span>
                  <span v-else>
                    <button class="page-link" @click="pageChange('Next')">
                      Next
                    </button>
                  </span>
                </li>
              </ul>
            </nav>
            <CollectPayments
              ref="cp"
              :AppModelId="AppModelId"
              :removeids="false"
            >
            </CollectPayments>
          </div>
        </div>

        <!-- Tab panes Send Email -->
        <div class="tab-content" style="width: 100%" v-if="showEmail">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mailbox</h4>
            </div>

            <div class="container">
              <div class="row">
                <div class="col-4 col-md-4">
                  <div class="row">
                    <div class="col-xl">
                      <div
                        class="list-group text-left"
                        id="list-tab"
                        role="tablist"
                      >
                        <a
                          style="word-break: break-all"
                          v-for="(email, ndxA03) in emailTempsList"
                          :key="ndxA03"
                          @click="emailTempsListClick(email)"
                          :class="selectedEmailTempClass(email)"
                          role="tab"
                          href="#list-home"
                          aria-selected="true"
                          ><i :class="selectedEmailTempIcon(email)"></i
                          >{{ email.name }}</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-8 col-md-8">
                  <form class="">
                    <div class="card-body">
                      <h3 class="card-title">Compose New Message</h3>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Template Name:"
                          maxlength="40"
                          :disabled="Ename == true"
                          v-model="aSingleEmail.name"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Send:"
                          maxlength="100"
                          :disabled="Eemail == true"
                          v-model="pat.email"
                        />
                      </div>
                      <div class="form-group">
                        <input
                          class="form-control"
                          placeholder="Subject:"
                          maxlength="100"
                          :disabled="Esubj == true"
                          v-model="aSingleEmail.emailSubject"
                        />
                      </div>
                      <!-- <div class="form-group" v-if="false">
                        <textarea
                          v-model="aSingleEmail.emailText"
                          class="textarea_editor form-control"
                          rows="15"
                          maxlength="150"
                          placeholder="Enter text ..."
                        ></textarea>
                      </div> -->

                      <div v-if="setReadonly == false">
                        <Editor
                          v-model="aSingleEmail.emailText"
                          editorStyle="height: 200px"
                        />
                      </div>
                      <div v-else-if="setReadonly == true">
                        <Editor
                          readonly
                          v-model="aSingleEmail.emailText"
                          editorStyle="height: 200px"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                @click="sendEmail()"
                :disabled="updButton == 0"
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
              >
                Send Email
              </button>
            </div>
          </div>
        </div>

        <!-- Tab panes Send Text -->
        <div class="tab-content" style="width: 100%" v-if="showSms">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Send a text</h4>
            </div>
            <div class="modal-body">
              <div class="container">
                <div class="row">
                  <div class="col-4 col-md-4">
                    <div class="row">
                      <div class="col-xl">
                        <div
                          class="list-group text-left"
                          id="list-tab"
                          role="tablist"
                        >
                          <a
                            style="word-break: break-all"
                            v-for="(sms, ndxA02) in smsTempsList"
                            :key="ndxA02"
                            @click="smsTempsListClick(sms)"
                            :class="selectedSmsTempClass(sms)"
                            id="list-home-list"
                            data-toggle="list"
                            href="#list-home"
                            role="tab"
                            aria-controls="home"
                            aria-selected="true"
                            ><i :class="selectedSmsTempIcon(sms)"></i>
                            {{ sms.name }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-8 col-md-8">
                    <form class="floating-labels m-t-40">
                      <div
                        class="form-group m-b-40"
                        :class="[aSingleSms.name.length > 0 ? 'focused' : '']"
                      >
                        <input
                          type="text"
                          class="form-control"
                          id="templateName"
                          maxlength="40"
                          :disabled="Ename1 == true"
                          v-model="aSingleSms.name"
                        /><span class="bar"></span>
                        <label for="templateName">Template Name</label>
                      </div>
                      <div
                        class="form-group m-b-40"
                        :class="[pat.phone != null ? 'focused' : '']"
                      >
                        <input
                          v-mask="'###-###-####'"
                          type="tel"
                          class="form-control"
                          id="to"
                          :disabled="Enumber == true"
                          v-model="pat.phone"
                        /><span class="bar"></span>
                        <label for="to">To</label>
                      </div>
                      <div
                        class="form-group m-b-40"
                        :class="[
                          aSingleSms.smsText.length > 0 ? 'focused' : '',
                        ]"
                      >
                        <label for="comment-text" class="control-label"
                          >Type your text</label
                        >
                        <Editor
                          v-if="Esubj1"
                          :readonly="true"
                          v-model="aSingleSms.smsText"
                          editorStyle="height: 200px"
                        >
                          <template #toolbar>
                            <span class="ql-formats"> </span>
                          </template>
                        </Editor>
                        <Editor
                          v-else
                          v-model="aSingleSms.smsText"
                          editorStyle="height: 200px;background-color:grey"
                        >
                          <template #toolbar>
                            <span class="ql-formats"> </span>
                          </template>
                        </Editor>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                :disabled="updButton == 0"
                @click="sendSms()"
              >
                Send Text
              </button>
            </div>
          </div>
        </div>

        <!-- Tab panes Request payment -->
        <PaymentRequest
          :p_visitId="p_visitId"
          v-if="showRequestPayment"
          :FetchTableData="FetchTableData"
        />
        <div
          class="tab-content"
          style="width: 100%"
          v-if="showRequestPayment123"
        >
          <div class="row col-12">
            <h4 class="font-weight-bold h4-responsive">Payment Request</h4>
            <br /><br />

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputNumber
                  showButtons
                  v-model="aSingleRequestPayment.amount"
                  mode="decimal"
                  :maxFractionDigits="2"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Amount(In $)</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputText
                  id="inputtext"
                  type="text"
                  v-model="aSingleRequestPayment.email"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Email</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <span class="p-float-label">
                <InputMask
                  v-model="aSingleRequestPayment.phone"
                  mask="999-999-9999"
                  style="width: 100%"
                  class="float-class"
                />
                <label for="inputtext">Phone Number</label>
              </span>
            </div>

            <div class="p-field p-col-12">
              <label for="" class="control-label">Comment:</label>
              <textarea
                v-model="aSingleRequestPayment.comment"
                maxlength="255"
                class="form-control"
                id="comment-text"
                rows="2"
                style="width: 100%"
              ></textarea>
            </div>
            <div class="modal-footer p-col-12">
              <button
                type="button"
                class="btn btn-outline-success waves-effect waves-light col-12"
                id="creditCardPayment"
                @click="savePaymentRequest()"
              >
                Send Payment Request
              </button>
            </div>
          </div>
        </div>

        <!-- Tab panes Request assign physician -->
        <div class="tab-content" style="width: 100%" v-if="showPhysician">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">
                  Assign Physician
                </h4>
              </div>

              <div class="modal-body mb-1 pt-2">
                <div class="table-responsive">
                  <table
                    id="config-table3"
                    class="table display table-bordered table-striped no-wrap"
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th>Action</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Email</th>
                        <th>Phone</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(phy, ndxA01) in phyList" :key="ndxA01">
                        <td>
                          <!-- <button
                            @click="assignPhysicianSaveClick(phy)"
                            :class="assignPhysicianStyle(phy)"
                          >
                            {{
                              phy.UserId == pat.physicianId
                                ? "Assigned Physician"
                                : "Assign Physician"
                            }}
                          </button>  -->
                          <button
                            v-if="phy.isPhysicianActive == true"
                            class="btn btn-info unassignPhyStage"
                          >
                            Assigned
                          </button>
                          <button
                            v-else
                            @click="assignPhysicianSaveClick(phy)"
                            class="btn btn-dark assignPhyStage"
                          >
                            Assign Physician
                          </button>
                        </td>
                        <td>{{ phy.firstName + " " + phy.lastName }}</td>
                        <td>{{ phy.dob }}</td>
                        <td>
                          <span
                            class="__cf_email__"
                            data-cfemail="7c043c1b111d1510521f1311"
                            >{{ phy.email }}</span
                          >
                        </td>
                        <td>{{ phy.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script src="./mixins/DropDownModal.js"></script>


<style scoped>
.p-editor-content {
  background-color: #f0f2f4;
}
.form-floating-label {
  position: relative;
}
.form-floating-label [type="text"],
.form-floating-label [type="password"],
.form-floating-label [type="date"],
.form-floating-label [type="datetime"],
.form-floating-label [type="datetime-local"],
.form-floating-label [type="month"],
.form-floating-label [type="week"],
.form-floating-label [type="email"],
.form-floating-label [type="number"],
.form-floating-label [type="search"],
.form-floating-label [type="tel"],
.form-floating-label [type="time"],
.form-floating-label [type="url"],
.form-floating-label [type="color"],
.form-floating-label textarea {
  margin-bottom: 0;
  color: black;
  /*            color:#8a8a8a ;
    */
  font-size: 15px;
  font-weight: 300;
  padding: 38px 1rem 1rem 2px;
}
.dummy-label {
  margin-top: -7px;
  margin-bottom: 0;
  color: #343a40;
  font-size: 16px;
  font-weight: bold;
}
.form-floating-label label {
  color: #cacaca;
  font-size: 14px;
  position: absolute;
  pointer-events: none;
  left: 2px;
  bottom: 0;
  transition: all 0.2s ease-in;
  font-weight: 300;
}
.form-floating-label textarea ~ label {
  top: 20px;
  font-size: 18px;
  font-weight: 300;
}
.form-floating-label input:focus ~ label,
.form-floating-label input:disabled[value] ~ label,
.form-floating-label.has-value input ~ label {
  top: 0;
  font-size: 13px;
  color: dodgerblue;
  font-weight: 400;
}
.form-floating-label textarea:focus ~ label,
.form-floating-label.has-value textarea ~ label {
  top: 0;
  font-size: 13px;
  color: dodgerblue;
  font-weight: 400;
}
.float-textarea,
.float-class:hover {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 1px solid rgb(235, 235, 235);
  /* box-shadow: none; */
  width: 98%;
}
.float-textarea:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  /* box-shadow: none; */
  width: 98%;
}
.float-class:focus {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  background: transparent;
  border-bottom: 2px solid rgb(240, 141, 11);
  box-shadow: none;
}
.label_select {
  margin-top: -23px;
  margin-left: 0px;
}
.activeColor {
  background-color: #fb9678;
  color: white;
}
.colorActive {
  color: #f95c2e;
}
.disabledColor {
  color: gray;
  background: lightgrey;
}
.asc-desc-btn {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
  color: honeydew;
  float: right;
}
.p-chip-red {
  background-color: #c22d00;
  color: #ffffff;
  border-radius: 6px;
  padding: 0 0.2rem;
  margin-right: 5px;
  margin-top: 2px;
  height: 20px;
  font-size: small;
}
td {
  border: 1px solid #000;
}

tr td:last-child {
  width: 1%;
  white-space: nowrap;
}

.p-chip-green {
  background-color: #00c292;
  color: #ffffff;
  border-radius: 6px;
  padding: 0 0.2rem;
  margin-right: 5px;
  margin-top: 2px;
  height: 20px;
  font-size: small;
}
.togglebutton {
  margin-left: -3px;
}
</style>
